import useDashboardData from './useDashboardData';

export { useDashboardData };
